import React from 'react';
import styled from 'styled-components';
import { CheckCircleOutlined } from '@ant-design/icons';
import Button from '../../components/molecules/button';
import { useIntl } from '../../common/config/i18n';
import { circulationsActions } from 'common/config/store';
import { useDispatch } from 'react-redux';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 120px;
  font-weight: bold;
  color: #00acd0;
  text-align: center;
`;
const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
`;

const Confirmation: React.FC = () => {
  const { t } = useIntl();
  const dispatch = useDispatch();

  return (
    <div>
      <Wrapper>
        <CheckCircleOutlined style={{ color: '#00acd0', fontSize: 60, marginBottom: 40 }} />
        {t('confirmation', 'TEXT_CONF_PAGE_OK_1')}
        <br />
        {t('confirmation', 'TEXT_CONF_PAGE_OK_2')}
      </Wrapper>
      <ButtonWrapper>
        <Button
          onClick={() => {
            dispatch(circulationsActions.setShoudUsePersistedCirculationsFilters(true));
            window.opener && window.opener.location.reload();
            window.close();
          }}
          borderRadius="5px"
          backgroundColor="#E60075"
        >
          {t('confirmation', 'CLOSE_BUTTON')}
        </Button>
      </ButtonWrapper>
    </div>
  );
};
export default Confirmation;
